/* Bisou Rivage — Mockup slide (format-aware)
 * Pose le tirage du produit dans la scene mockup (.rv5-mk-stage) via deformation CSS matrix3d.
 * La scene + les 4 coins changent selon le FORMAT choisi (A4/A3/A2), via l'event bisou:variant-change.
 * Additif & reversible : ne modifie aucune logique existante (variant-ui, media-gallery, cart). */
(function () {
  function adj(m){return [m[4]*m[8]-m[5]*m[7],m[2]*m[7]-m[1]*m[8],m[1]*m[5]-m[2]*m[4],m[5]*m[6]-m[3]*m[8],m[0]*m[8]-m[2]*m[6],m[2]*m[3]-m[0]*m[5],m[3]*m[7]-m[4]*m[6],m[1]*m[6]-m[0]*m[7],m[0]*m[4]-m[1]*m[3]];}
  function mm(a,b){var c=[];for(var i=0;i<3;i++)for(var j=0;j<3;j++){var s=0;for(var k=0;k<3;k++)s+=a[3*i+k]*b[3*k+j];c[3*i+j]=s;}return c;}
  function mv(m,v){return [m[0]*v[0]+m[1]*v[1]+m[2]*v[2],m[3]*v[0]+m[4]*v[1]+m[5]*v[2],m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];}
  function b2p(a){var m=[a[0],a[2],a[4],a[1],a[3],a[5],1,1,1];var v=mv(adj(m),[a[6],a[7],1]);return mm(m,[v[0],0,0,0,v[1],0,0,0,v[2]]);}
  function matrix3d(w,h,d){
    var t=mm(b2p([d[0][0],d[0][1],d[1][0],d[1][1],d[2][0],d[2][1],d[3][0],d[3][1]]),adj(b2p([0,0,w,0,w,h,0,h])));
    for(var i=0;i<9;i++)t[i]/=t[8];
    return 'matrix3d('+[t[0],t[3],0,t[6],t[1],t[4],0,t[7],0,0,1,0,t[2],t[5],0,t[8]].join(',')+')';
  }

  function setup(stage){
    var print = stage.querySelector('.rv5-mk-print');
    var sceneImg = stage.querySelector('.rv5-mk-scene');
    if(!print || !sceneImg) return;
    var scenes = {}, cmap = {};
    try{ scenes = JSON.parse(stage.getAttribute('data-scenes') || '{}'); }catch(e){}
    try{ cmap = JSON.parse(stage.getAttribute('data-corners-map') || '{}'); }catch(e){}

    var fmt = 'A4';
    var fl = document.getElementById('rv5-bloc-fmt');
    if(fl && fl.dataset.initFormat) fmt = fl.dataset.initFormat;

    function warp(){
      var c = cmap[fmt] || cmap.A4;
      if(!c || c.length < 8) return;
      var W = stage.clientWidth, H = stage.clientHeight, SW = print.naturalWidth, SH = print.naturalHeight;
      if(!W || !H || !SW) return;
      print.style.width = SW + 'px';
      // leger debord pour couvrir proprement le tirage cuit dans la scene de reference
      var B = 1.012, cx = (c[0]+c[2]+c[4]+c[6])/4, cy = (c[1]+c[3]+c[5]+c[7])/4;
      var d = [
        [(cx+(c[0]-cx)*B)*W, (cy+(c[1]-cy)*B)*H],
        [(cx+(c[2]-cx)*B)*W, (cy+(c[3]-cy)*B)*H],
        [(cx+(c[4]-cx)*B)*W, (cy+(c[5]-cy)*B)*H],
        [(cx+(c[6]-cx)*B)*W, (cy+(c[7]-cy)*B)*H]
      ];
      print.style.transform = matrix3d(SW, SH, d);
      print.style.opacity = '1';
    }

    function applyFormat(f){
      if(!cmap[f]) f = 'A4';
      fmt = f;
      if(scenes[f] && sceneImg.getAttribute('src') !== scenes[f]) sceneImg.setAttribute('src', scenes[f]);
      warp();
    }

    if(!(print.complete && print.naturalWidth)) print.addEventListener('load', warp);
    if('ResizeObserver' in window){ new ResizeObserver(warp).observe(stage); }
    else { window.addEventListener('resize', warp); }

    applyFormat(fmt);
    document.addEventListener('bisou:variant-change', function (e) {
      if(e.detail && e.detail.format) applyFormat(e.detail.format);
    });
  }

  function init(){
    var stages = document.querySelectorAll('.rv5-mk-stage');
    for(var i = 0; i < stages.length; i++) setup(stages[i]);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
